// extracted by mini-css-extract-plugin
export default {"page":"hV4cLg8Ua1ER45_Ua_0t","containerUnderSubheader":"talswnloSK2Q7mC4X9vW"};